import axios from "axios";

export function getReceiveTransferDetail(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/receive-transfer/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
